import React from "react";
import {
  View,
  Text,
  Platform,
  StyleSheet,
  TouchableOpacity,
} from "react-native";

import AppTheme from "../../../AppTheme";
import appStyles from "../../../../appStyles";
import IntegrationToggle from "../../common/IntegrationToggle";
import IntegrationUpdatedTime from "../../common/IntegrationUpdatedTime";
import AccountSubTitle from "../../common/AccountSubTitle";

export default function Account({
  controller,
  account,
  toggleAccountStatus = () => {},
  editAccount = () => {},
  onLongPress,
}) {
  const updateAccount = (is_enabled) => {
    account.isEnabled = is_enabled;
    toggleAccountStatus(account, is_enabled);
  };

  return (
    <View style={[styles.account, appStyles.borderBottom]}>
      <TouchableOpacity
        style={{ flex: 1 }}
        onPress={() => editAccount(account)}
        onLongPress={onLongPress}
      >
        <Text style={styles.name}>{account.name}</Text>
        <AccountSubTitle count={account.attributesCount} label="attribute" />

        <IntegrationUpdatedTime
          controller={controller}
          time={account.last_updated}
          connected={account.isConnected}
        />
      </TouchableOpacity>

      {/* Toggle */}
      <IntegrationToggle
        onPress={updateAccount}
        isEnabled={account.isEnabled}
        isAutoTracked={account.isAutoTracked}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  account: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    height: 60,
    paddingLeft: 6,
  },
  name: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  caption: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  toggleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    borderRadius: 4,
    backgroundColor: "#F3F2F1",
    width: 78,
    padding: 4,
  },
  toggle: {
    width: 32,
    height: 32,
    borderRadius: 4,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  toggleIcon: {
    width: 20,
    height: 20,
  },
  toggleSelected: {
    backgroundColor: AppTheme.DEFAULT_COLOR,
  },
});
